import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { admins } from '../../../../environments/environment';
import { AUTH_CONSTANTS } from '../constants/auth.constants';

export const adminGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // First check if user is authenticated
  const isAuthenticated = await authService.isAuthenticated();
  if (!isAuthenticated) {
    await authService.signIn();
    return false;
  }

  // Check if user is admin
  const userFromCookie = authService.getUserFromCookie();
  if (!userFromCookie || !userFromCookie.email) {
    router.navigate([AUTH_CONSTANTS.ROUTES.HOME]);
    return false;
  }
  const userEmail = (userFromCookie.email as string).toLowerCase();
  const isAdmin = admins.emailAddress.includes(userEmail);
  if (!isAdmin) {
    router.navigate([AUTH_CONSTANTS.ROUTES.HOME]);
    return false;
  }

  return true;
};
